import React from 'react'
import Section from '../components/Section'
import '../assets/styles/checkout-process.css'

class ShippingInfo extends React.Component {
	componentDidMount() {
		document.querySelector('#sticky .col-md-10').style.display = 'none'
		document.querySelector('#sticky .col-md-2').style.display = 'none'
	}
	toggleBillingAddress() {
		document.querySelector('#billingForm').classList.toggle('active')
	}
	render() {
		return (
			<div className='main-container'>
				<section className='height-auto'>
					<div className='container'>
						<div className='row justify-content-center'>
							<span className='process-list__item col-md-3 col-12'>
								<h4 className='text-center'>
									<a href='/shipping'>Shipping Info</a>
									<hr />
								</h4>
							</span>
							<span className='process-list__item col-md-3 col-12'>
								<span className='process-list__middot' />
								<h4 className=' text-center'>
									<a href='/payment'>Payment</a>
								</h4>
								<span className='process-list__middot' />
							</span>
							<span className='process-list__item col-md-3 col-12'>
								<h4 className='text-center'>
									<a href='/confirmation'>Confirmation</a>
								</h4>
							</span>
						</div>
					</div>
				</section>

				{/* <Section id='usp__section'>
					<div className='col-md-4'>
						<div className='feature feature-2'>
							<FAI icon='lock' size='2x' />
							<div className='feature__body'>
								<h4 className=''>Secure Shopping</h4>
								<p>
									Lorem ipsum dolor sit amet consectetur,
									adipisicing elit. Corrupti, magni!
								</p>
							</div>
						</div>
					</div>
					<div className='col-md-4'>
						<div className='feature feature-2'>
							<FAI icon='credit-card' size='2x' />
							<div className='feature__body'>
								<h4 className=''>Payment Options</h4>
								<p>
									Lorem ipsum dolor sit amet consectetur,
									adipisicing elit. Corrupti, magni!
								</p>
							</div>
						</div>
					</div>
					<div className='col-md-4'>
						<div className='feature feature-2'>
							<FAI icon='undo-alt' size='2x' />
							<div className='feature__body'>
								<h4 className=''>2-Week Returns</h4>
								<p>
									Lorem ipsum dolor sit amet consectetur,
									adipisicing elit. Corrupti, magni!
								</p>
							</div>
						</div>
					</div>
				</Section>

				<Section id='login__section' className='pos--relative'>
					<div className='col-md-6'>
						<h4 className='light '>Save Your Progress</h4>
						<p>
							Login to autocomplete required information and speed
							up the checkout process. Or use super fast social
							media authorization
						</p>
					</div>
					<div className='col-md-3'>
						<a href='/'>
							<FAI
								icon={['fab', 'facebook-square']}
								size='2x'
								color='rgb(74, 74, 74)'
							/>
							<h4 className=''>Facebook Login</h4>
						</a>
					</div>
					<div className='col-md-3'>
						<a href='/'>
							<FAI
								icon={['fab', 'instagram']}
								size='2x'
								color='rgb(74, 74, 74)'
							/>
							<h4 className=''>Instagram Login</h4>
						</a>
					</div>
				</Section> */}

				<Section id='sAddress__section'>
					<div className='col-12'>
						<h3>Shipping Address</h3>
					</div>
					<div className='col-md-4'>{/* spacing column */}</div>
					<div className='col-md-8'>
						<form>
							<div className='row'>
								<div className='form-group col-12'>
									<label htmlFor='fullName'>Full Name</label>
									<input
										type='text'
										className='form-control'
										id='fullName'
										aria-describedby='nameHelp'
										placeholder='Marcela Garcia'
									/>
								</div>
							</div>
							<div className='row'>
								<div className='form-group col-md-7'>
									<label htmlFor='streetAddress'>
										Street Address
									</label>
									<input
										type='text'
										className='form-control'
										id='streetAddress'
										placeholder='123 Main St.'
									/>
								</div>
								<div className='form-group col-md-3'>
									<label htmlFor='aptNumber'>
										Apt Number
									</label>
									<input
										type='text'
										inputMode='numeric'
										pattern='[0-9]*'
										className='form-control'
										id='aptNumber'
										placeholder='opt. 2407'
									/>
								</div>
								<div className='form-group col-md-2'>
									<label htmlFor='zipCode'>Zip Code</label>
									<input
										type='text'
										inputMode='numeric'
										pattern='[0-9]*'
										className='form-control'
										id='zipCode'
										placeholder='90210'
									/>
								</div>
							</div>
							<div className='row'>
								<div className='form-group col-12'>
									<label htmlFor='city'>Town/City</label>
									<input
										type='text'
										className='form-control'
										id='city'
										placeholder='Beverly Hills'
									/>
								</div>
							</div>
							<div className='row'>
								<div className='form-group col-12'>
									<label htmlFor='country'>Country</label>
									<input
										type='text'
										className='form-control'
										id='country'
										placeholder='United States'
									/>
								</div>
							</div>
							<div className='row'>
								<div className='form-group col-12'>
									<label htmlFor='phone'>Phone Number</label>
									<input
										type='text'
										inputMode='numeric'
										pattern='[0-9]*'
										className='form-control'
										id='phone'
										placeholder='(310) 285-4950'
									/>
								</div>
							</div>
						</form>
					</div>
				</Section>

				<Section id='bAddress__section'>
					<div className='col-12'>
						<h3>Billing Address</h3>
					</div>
					<div className='col-md-4'>{/* spacing column */}</div>
					<div className='col-md-8'>
						<label htmlFor='sameAddress'>
							<input
								type='checkbox'
								name='address'
								id='sameAddress'
								onClick={this.toggleBillingAddress}
							/>
							<span className='text-muted'>
								Billing address the same as the Shipping address
							</span>
						</label>
						<form id='billingForm' className='active'>
							<div className='row'>
								<div className='form-group col-md-7'>
									<label htmlFor='bStreetAddress'>
										Street Address
									</label>
									<input
										type='text'
										className='form-control'
										id='bStreetAddress'
										placeholder='123 Main St.'
									/>
								</div>
								<div className='form-group col-md-3'>
									<label htmlFor='bAptNumber'>
										Apt Number
									</label>
									<input
										type='text'
										inputMode='numeric'
										pattern='[0-9]*'
										className='form-control'
										id='bAptNumber'
										placeholder='opt. 2407'
									/>
								</div>
								<div className='form-group col-md-2'>
									<label htmlFor='bZipCode'>Zip Code</label>
									<input
										type='text'
										inputMode='numeric'
										pattern='[0-9]*'
										className='form-control'
										id='bZipCode'
										placeholder='90210'
									/>
								</div>
							</div>
							<div className='row'>
								<div className='form-group col-12'>
									<label htmlFor='bCity'>Town/City</label>
									<input
										type='text'
										className='form-control'
										id='city'
										placeholder='Beverly Hills'
									/>
								</div>
							</div>
							<div className='row'>
								<div className='form-group col-12'>
									<label htmlFor='bCountry'>Country</label>
									<input
										type='text'
										className='form-control'
										id='bCountry'
										placeholder='United States'
									/>
								</div>
							</div>
						</form>
					</div>
				</Section>

				<Section id='delivery__section'>
					<div className='col-12'>
						<h3>Delivery</h3>
					</div>
					<div className='col-md-4'>{/* spacing column */}</div>
					<div className='col-md-8'>
						<div className='row delivery-option'>
							<div className='col-md-8'>
								<label htmlFor='standard'>
									<input
										type='radio'
										name='delivery'
										id='standard'
									/>
									<h4>Standard Shipping</h4>
									<p className='text-muted'>
										3-5 Business Days
									</p>
								</label>
							</div>
							<div className='col-md-4 text-right'>$7.00</div>
						</div>
						<div className='row delivery-option'>
							<div className='col-md-8'>
								<label htmlFor='express'>
									<input
										type='radio'
										name='delivery'
										id='express'
									/>
									<h4>Express Shipping</h4>
									<p className='text-muted'>
										2-3 Business Days
									</p>
								</label>
							</div>
							<div className='col-md-4 text-right'>$19.00</div>
						</div>
						<div className='row delivery-option'>
							<div className='col-md-8'>
								<label htmlFor='one-day'>
									<input
										type='radio'
										name='delivery'
										id='one-day'
									/>
									<h4>Next Day Shipping</h4>
									<p className='text-muted'>1 Business Day</p>
								</label>
							</div>
							<div className='col-md-4 text-right'>$29.00</div>
						</div>
					</div>
				</Section>

				<Section id='proceed__section'>
					<div className='col-12 text-right'>
						<a href='/payment' className='btn btn--primary'>
							<span className='btn__text'>
								Proceed to Payment
							</span>
						</a>
					</div>
				</Section>
			</div>
		)
	}
}

export default ShippingInfo
